import {ReactNode} from "react";
import {Paper} from "@mui/material";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";
import CommonCssStyles from "../../css/CommonCssStyles";


export interface PageProps {
    children: ReactNode[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        page: CommonCssStyles.getRootPageStyles(theme),
    })
);

export default function Page({children}: Readonly<PageProps>) {
    const classes = useStyles();

    return (
        <Paper className={classes.page}>
            {children}
        </Paper>
    );
}